"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseTextTransforms = parseTextTransforms;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const ModelText_1 = require("../../../ModelText");
function parseTextTransforms(text) {
    const rawValue = text.value;
    const changed = String(rawValue).replace(/\\n/g, '\n').trimEnd();
    if ((0, sigma_engine_shared_1.isNetRef)(rawValue)) {
        rawValue.setName(changed);
    }
    else {
        text.value = changed;
    }
    const encoded = (0, ModelText_1.encodeRawText)({ raw: changed, dialects: [ModelText_1.TextDialect.Kicad] });
    if (encoded.textTransforms.length > 0) {
        text.textTransforms = encoded.textTransforms;
    }
    return text;
}
//# sourceMappingURL=parseTextTransforms.js.map